import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 50px;

  span {
    font-size: 200px;
    margin-top: -70px;
  }

  h1 {
    font-size: 36px;
    color: ${({ theme }) => theme.colors.black};
    font-family: 'Sora', sans-serif;
    font-weight: bold;
    text-align: center;
  }

  h4 {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.grey};
    font-family: 'Sora', sans-serif;
    margin-top: 15px;
    text-align: center;
    width: 100%;
    max-width: 700px;
  }
`;
